import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Importante
import '../styles/Register.css'; // Importe o CSS específico do formulário
import { useNotification } from '../components/NotificationContext';

function Register() {
  const { showNotification } = useNotification();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [activationCode, setActivationCode] = useState('');

  // Função para obter parâmetros da URL
  function getURLParameter(name) {
    return decodeURIComponent(
      (
        new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.search) || [
          null,
          '',
        ]
      )[1].replace(/\+/g, '%20')
    ) || null;
  }

  // useEffect para capturar o código de indicação na URL
  useEffect(() => {
    const codeFromUrl = getURLParameter('code');
    if (codeFromUrl) {
      setActivationCode(codeFromUrl);
    }
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    // Verificar se as senhas coincidem
    if (password !== confirmPassword) {
      showNotification('As senhas não coincidem. Por favor, verifique e tente novamente.', 'error');
      return;
    }

    // Se o campo de indicação estiver vazio, definimos como null
    const indicacaoValue = activationCode.trim() === '' ? null : activationCode;

    // Montar objeto de dados
    const data = {
      name: name,
      email: email,
      password: password,
      ...(indicacaoValue && { indicacao: indicacaoValue }),
    };

    console.log('Dados sendo enviados:', data);

    // Fazer a requisição
    fetch('https://x8ki-letl-twmt.n7.xano.io/api:g_BmLeE8/auth/signup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((errorData) => {
            throw new Error(`Erro ${response.status}: ${errorData.message}`);
          });
        }
        return response.json();
      })
      .then((responseData) => {
        console.log('Success:', responseData);
        showNotification('Registro realizado com sucesso!', 'success');
        // Redirecionar (pode ser substituído por navegação via React Router, se preferir)
        window.location.href = '/';
      })
      .catch((error) => {
        console.error('Error:', error);
        showNotification('Erro no registro: ' + error.message, 'error');
      });
  };

  return (
    <div className="login-container">
      <div className="login-box">
        
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="name">Nome completo</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="confirmPassword">Confirmar Senha</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="activationCode">Possui código de indicação?</label>
            <input
              type="text"
              id="activationCode"
              value={activationCode}
              onChange={(e) => setActivationCode(e.target.value)}
            />
          </div>

          <div className="input-group">
            <button type="submit">Registrar</button>
          </div>

          {/* Botão (ou link) de Voltar ao Login */}
        <Link to="/" className="back-button">
          Voltar ao Login
        </Link>
        </form>

      </div>
    </div>
  );
}

export default Register;
